import { useEffect } from 'react'

import { useUnreadMessages } from '~contexts/unread-messages-provider'
import { useUnreadInternalChats } from '~contexts/unread-internal-chats-provider'
import UnreadIcon1 from '~images/logo/favicon-alert-1.png'
import UnreadIcon2 from '~images/logo/favicon-alert-2.png'
import UnreadIcon3 from '~images/logo/favicon-alert-3.png'
import UnreadIcon4 from '~images/logo/favicon-alert-4.png'
import UnreadIcon5 from '~images/logo/favicon-alert-5.png'
import UnreadIcon6 from '~images/logo/favicon-alert-6.png'
import UnreadIcon7 from '~images/logo/favicon-alert-7.png'
import UnreadIcon8 from '~images/logo/favicon-alert-8.png'
import UnreadIcon9 from '~images/logo/favicon-alert-9.png'
import UnreadIcon10 from '~images/logo/favicon-alert-10.png'
import DefaultIcon from '~images/logo/favicon.png'
import { useActionItems } from '~contexts/action-item-provider'

export const FaviconHandler = () => {
    const { unreadMessages } = useUnreadMessages()
    const { unreadInternalChats } = useUnreadInternalChats()
    const { actionItems } = useActionItems()

    const numUnread = unreadMessages + unreadInternalChats + actionItems.length

    const unreadIcons = [
        UnreadIcon1,
        UnreadIcon2,
        UnreadIcon3,
        UnreadIcon4,
        UnreadIcon5,
        UnreadIcon6,
        UnreadIcon7,
        UnreadIcon8,
        UnreadIcon9,
        UnreadIcon10,
    ]

    const getUnreadIcon = () => {
        if (numUnread >= 10) {
            return unreadIcons[9]
        } else if (numUnread > 0) {
            return unreadIcons[numUnread - 1]
        } else {
            return DefaultIcon
        }
    }

    useEffect(() => {
        const favicon = document.querySelector(
            "link[rel*='icon']",
        ) as HTMLLinkElement
        if (favicon) {
            favicon.href = getUnreadIcon()
        }
    }, [unreadMessages, unreadInternalChats, actionItems])

    return null
}
